import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Col,
  Form,
  Row,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../../constant/theme";
import CustomSizePerPage from "../../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../../helpers/api_helper";
import CustomInput from "../../../../CustomControls/CustomInput";
import CustomSelect from "../../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../../CustomControls/CustomFlatpickr";
import moment from "moment";

import { useFilter } from "../../../../../context/FilterContext";

import {
  POST_DDLGetTestMasterByCompanyID,
  POST_GetControlCenterInwardMaterialMachineCertificateEmailDetail,
  POST_GetControlCenterInwardStatistics,
  POST_GetCustomerInwardList,
  POST_GetCustomerProjectList,
} from "../../../../helpers/url_helper";

const CustomerInward = () => {
  const { filter, updateFilter } = useFilter();
  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [testOptions, setTestOptions] = useState([]);

  const [isReset, setIsReset] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "customer-inward" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "customer-inward" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "customer-inward" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "customer-inward" ? filter?.orderBy : "asc"
  );

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const currentDate = new Date();
  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      InwardNo:
        filter && filter?.page == "customer-inward" ? filter?.InwardNo : "",
      FromDate:
        filter && filter?.page == "customer-inward"
          ? filter?.FromDate
          : new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate:
        filter && filter?.page == "customer-inward"
          ? filter?.ToDate
          : new Date(),

      CustomerProjectIDEncrypted:
        filter && filter?.page == "customer-inward"
          ? filter?.CustomerProjectIDEncrypted
          : "",
      TCNo: filter && filter?.page == "customer-inward" ? filter?.TCNo : "",

      TestMasterIDEncrypted:
        filter && filter?.page == "customer-inward"
          ? filter?.TestMasterIDEncrypted
          : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      InwardNo,
      FromDate,
      ToDate,
      CustomerProjectIDEncrypted,
      TCNo,
      TestMasterIDEncrypted,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ListOfInward: [],
      TotalInward: 0,
      TotalTC: 0,
      TotalTest: 0,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { ListOfInward, TotalInward, TotalTC, TotalTest },
  } = formik;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      InwardNo: "",
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate: new Date(),
      CustomerProjectIDEncrypted: "",
      TCNo: "",
      TestMasterIDEncrypted: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    getCustomerProjectDDL();
    getTestDDL();
  }, []);

  const getCustomerProjectDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestDDL = async () => {
    setIsLoading(true);
    await post(POST_DDLGetTestMasterByCompanyID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestType: 0, // 0 - All, 1 - DT, 2 - NDT
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestOptions(
            response?.List?.map((item) => ({
              label: item.TestName,
              value: item.TestMasterIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "customer-inward",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      InwardNo: InwardNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      TCNo: TCNo,
      TestMasterIDEncrypted: TestMasterIDEncrypted,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      InwardNo: InwardNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      TCNo: TCNo,
      TestMasterIDEncrypted: TestMasterIDEncrypted,
    };

    await post(POST_GetCustomerInwardList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        formik.setValues({
          ListOfInward: response?.ListOfInward?.map((item) => ({
            ...item,
            showDetail: false,
          })),
          TotalInward: response?.TotalInward,
          TotalTC: response?.TotalTC,
          TotalTest: response?.TotalTest,
        });
        setIsLoading(false);
        if (page > 1 && response?.ListOfInward?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showTestingApprovalModal, setShowTestingApprovalModal] =
    useState(false);
  const [inwardMaterialID, setInwardMaterialID] = useState("");

  useEffect(() => {
    if (!showTestingApprovalModal) {
      setInwardMaterialID("");
    }
  }, [showTestingApprovalModal]);

  const [listOfLetterRefDoc, setListOfLetterRefDoc] = useState([]);
  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);

  const getListOfLetterRefDoc = async (listLetterRefNoDoc) => {
    setListOfLetterRefDoc([]);
    if (listLetterRefNoDoc) {
      setListOfLetterRefDoc(listLetterRefNoDoc);
      setShowLetterRefDocModal(true);
    }
  };

  const [showInwardStatisticsModal, setShowInwardStatisticsModal] =
    useState(false);
  const [listOfInwardStatistics, setListOfInwardStatistics] = useState([]);

  const getInwardStatistics = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetControlCenterInwardStatistics, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setListOfInwardStatistics(response?.ListOfInwardStatistics);
        } else {
          setListOfInwardStatistics([]);
        }
        setShowInwardStatisticsModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showSendMachineCertificateModal, setShowSendMachineCertificateModal] =
    useState(false);

  const openSendMachineCertificateDialog = async (
    inwardID,
    inwardMaterialID
  ) => {
    setIsLoading(true);
    await post(
      POST_GetControlCenterInwardMaterialMachineCertificateEmailDetail,
      {
        InwardIDEncrypted: inwardID,
        InwardMaterialIDEncrypted: inwardMaterialID,
      }
    )
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendMachineCertificate.setValues({
            smcListOfMachineCertificate: response?.ListOfMachine?.map((x) => ({
              ...x,
              MachineCertificateFilePath: x?.MachineCertificateFilePath,
              MachineCertificateFileName: x?.MachineCalibrationDocumentFileName,
            })),
          });
        } else {
          formikSendMachineCertificate.resetForm();
        }

        setShowSendMachineCertificateModal(true);

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaSendMachineCertificate = Yup.object().shape({});

  const formikSendMachineCertificate = useFormik({
    validationSchemaSendMachineCertificate,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendMachineCertificate(values, formikHelpers),
    initialValues: {
      smcListOfMachineCertificate: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { smcListOfMachineCertificate },
  } = formikSendMachineCertificate;

  const handleValidSubmitSendMachineCertificate = async (values) => {};

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0"> Inward</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <label>Inward Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search TC No"}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Test"
                              name="TestMasterIDEncrypted"
                              placeholder={"Select Test"}
                              options={testOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={2}>
                            <div className="mb-2">
                              <label className="mb-1">&nbsp;</label>
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm mb-1 me-2"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div className="d-flex">
                  <div style={{ width: showFilter ? "90%" : "100%" }}>
                    <div className="bootstrap-badge pt-2">
                      <label
                        className="me-1 badge-primary badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Inward : {TotalInward}
                      </label>

                      <label
                        className="me-1 badge-success badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        TC : {TotalTC}
                      </label>
                      <label
                        className="me-1 badge-dark badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Test : {TotalTest}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <div
                    id="ControlCenter-tbl_wrapper"
                    className="dataTables_wrapper no-footer mt-1"
                  >
                    <table
                      id="ControlCenter-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              width: "3%",
                            }}
                          ></th>
                          <th
                            style={{
                              width: "12%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("InwardDate");
                            }}
                          >
                            Inward No | Date
                            <span className="ml-1">
                              {sortBy == "InwardDate" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "12%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("BranchName");
                            }}
                          >
                            Branch Name
                            <span className="ml-1">
                              {sortBy == "BranchName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>

                          <th
                            style={{
                              width: "15%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("ProjectName");
                            }}
                          >
                            Project
                            <span className="ml-1">
                              {sortBy == "ProjectName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "10%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("LetterRefNo");
                            }}
                          >
                            Letter Ref No
                            <span className="ml-1">
                              {sortBy == "LetterRefNo" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "10%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("ReportingTo");
                            }}
                          >
                            Reporting To
                            <span className="ml-1">
                              {sortBy == "ReportingTo" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "10%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("BillingTo");
                            }}
                          >
                            Billing To
                            <span className="ml-1">
                              {sortBy == "BillingTo" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              textAlign: "left",
                              width: "10%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("SampleSubmittedBy");
                            }}
                          >
                            Submitted By
                            <span className="ml-1">
                              {sortBy == "SampleSubmittedBy" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfInward?.length > 0 ? (
                          ListOfInward?.map((item, indx) => (
                            <>
                              <tr key={indx}>
                                <td
                                  rowSpan={item?.showDetail == true ? 4 : 3}
                                  style={{
                                    verticalAlign: "top",
                                    whiteSpace: "normal",
                                    minWidth: "55px",
                                  }}
                                  className="p-1 ps-0 pe-0"
                                >
                                  <Link
                                    className="icon-box icon-box-md ms-1 mb-1"
                                    title="View Material Inward"
                                    to={`/view-material-inward/${window.btoa(
                                      item?.InwardIDEncrypted
                                    )}`}
                                  >
                                    {SVGICON.View}
                                  </Link>
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md ms-1 mb-1"
                                    title="Statistics"
                                    onClick={() => {
                                      getInwardStatistics(
                                        item?.InwardIDEncrypted
                                      );
                                    }}
                                  >
                                    {SVGICON.Project}
                                  </Link>
                                  {item?.ListOfScanCopyFile?.length > 0 ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md ms-1 mb-1"
                                      title="Show All Scan Copys"
                                      onClick={() => {
                                        const files =
                                          item?.ListOfScanCopyFile || []; // assuming ListOfScanCopyFiles is an array of URLs
                                        files.forEach((file) => {
                                          window.open(
                                            file.ScanCopyFilePath,
                                            "_blank"
                                          );
                                        });
                                      }}
                                    >
                                      {SVGICON.PDF}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.InwardNo ? (
                                    item.InwardNo
                                  ) : (
                                    <b>Draft Saved</b>
                                  )}
                                  {" | "} <label>{item.InwardDate}</label>
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.BranchName}
                                </td>

                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.ProjectName}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.LetterRefNo} &nbsp;{" "}
                                  {item?.ListOfLetterRefDoc?.length > 0 ? (
                                    <Link
                                      to="#"
                                      title="Letter Ref Doc"
                                      className="text-primary"
                                      onClick={() => {
                                        getListOfLetterRefDoc(
                                          item?.ListOfLetterRefDoc
                                        );
                                      }}
                                    >
                                      View File
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.ReportingTo}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.BillingTo}
                                </td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.SampleSubmittedBy}
                                </td>
                              </tr>
                              <tr key={`${indx}.1`}>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                    verticalAlign: "top",
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="pt-0 pb-0"
                                >
                                  <div className="d-flex">
                                    <label
                                      className="text-secondary"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "45px",
                                      }}
                                    >
                                      TC No: &nbsp;
                                    </label>
                                    <div style={{ textAlign: "left" }}>
                                      {item?.TCNos}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr key={`${indx}.2`}>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                    verticalAlign: "top",
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `ListOfInward[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="pt-0 pb-0"
                                >
                                  <div className="d-flex">
                                    <label
                                      className="text-secondary"
                                      style={{
                                        // textAlign: "left",
                                        minWidth: "80px",
                                      }}
                                    >
                                      Work Detail: &nbsp;
                                    </label>
                                    <div style={{ textAlign: "left" }}>
                                      {item.ProjectDetails}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                key={`${indx}.3`}
                                style={{
                                  display:
                                    item.showDetail == true ? "" : "none",
                                }}
                              >
                                <td
                                  colSpan={9}
                                  style={{
                                    textAlign: "left",
                                    verticalAlign: "top",
                                  }}
                                  className="p-0"
                                >
                                  <table
                                    className="table dataTable no-footer mb-0"
                                    style={{
                                      border: "1px solid var(--rgba-primary-3)",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{ width: "5%" }}
                                          className="pt-1 pb-1 newPara"
                                        ></th>
                                        <th
                                          style={{ width: "25%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          TC No
                                        </th>
                                        <th
                                          style={{ width: "35%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          Sample Detail
                                        </th>
                                        <th
                                          style={{ width: "20%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          Condition
                                        </th>
                                        <th
                                          style={{
                                            width: "20%",
                                            textAlign: "left",
                                          }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          Size
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.ListOfInwardMaterials?.length >
                                      0 ? (
                                        item?.ListOfInwardMaterials?.map(
                                          (m, mIndex) => (
                                            <>
                                              <tr key={mIndex}>
                                                <td
                                                  rowSpan={2}
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m?.tcTestingActionStatus >
                                                  1 ? (
                                                    m?.tcUploadScanCopyActionStatus >
                                                      1 &&
                                                    m?.ScanCopyFilePath &&
                                                    m?.MachineCertificateFilePathCount >
                                                      0 ? (
                                                      <Link
                                                        to="#"
                                                        className="icon-box icon-box-md ms-1 mb-1"
                                                        title="Send Machine Certificate"
                                                        onClick={() => {
                                                          if (
                                                            m?.IsHold == false
                                                          ) {
                                                            openSendMachineCertificateDialog(
                                                              item?.InwardIDEncrypted,
                                                              m?.InwardMaterialIDEncrypted
                                                            );
                                                          }
                                                        }}
                                                        disabled={m?.IsHold}
                                                      >
                                                        {SVGICON.Certificate}
                                                      </Link>
                                                    ) : (
                                                      ""
                                                    )
                                                  ) : (
                                                    ""
                                                  )}
                                                  {m?.tcUploadScanCopyActionStatus >
                                                    1 && (
                                                    <>
                                                      {m?.tcUploadScanCopyActionStatus >
                                                        1 &&
                                                        m?.ScanCopyFilePath && (
                                                          <Link
                                                            to="#"
                                                            className="icon-box icon-box-md ms-1 mb-1"
                                                            title="Show Scan Copy"
                                                            onClick={() => {
                                                              if (
                                                                m?.IsHold ==
                                                                false
                                                              ) {
                                                                window.open(
                                                                  m?.ScanCopyFilePath,
                                                                  "_blank"
                                                                );
                                                              }
                                                            }}
                                                            disabled={m?.IsHold}
                                                          >
                                                            {SVGICON.PDF}
                                                          </Link>
                                                        )}
                                                    </>
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.TCNo}{" "}
                                                  {m?.IsHold ? (
                                                    <>
                                                      <b>[Hold]</b>
                                                      <OverlayTrigger
                                                        trigger={[
                                                          "hover",
                                                          "focus",
                                                        ]}
                                                        key={mIndex}
                                                        responsive={true}
                                                        overlay={
                                                          <Tooltip className="toltip-popover">
                                                            <strong className="p-1">
                                                              {m?.HoldReason}
                                                            </strong>
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <span>
                                                          <i
                                                            className="fa fa-info-circle"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#9698ab",
                                                            }}
                                                          ></i>
                                                        </span>
                                                      </OverlayTrigger>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.SampleDetail}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.Condition}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                    textAlign: "left",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.Size}
                                                </td>
                                              </tr>
                                              <tr
                                                key={`${mIndex}.1`}
                                                style={{
                                                  display:
                                                    item.showDetail == true
                                                      ? ""
                                                      : "none",
                                                }}
                                              >
                                                <td
                                                  colSpan={4}
                                                  style={{
                                                    textAlign: "left",
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="pt-0 pb-0"
                                                >
                                                  <div className="d-flex">
                                                    <label
                                                      className="text-secondary"
                                                      style={{
                                                        minWidth: "70px",
                                                      }}
                                                    >
                                                      Test Name: &nbsp;
                                                    </label>
                                                    <div
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {m.TestNames}
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={8}
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            <div>{"No Record Found..."}</div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="border-0 p-0">
                                <td colSpan={9} className="p-0">
                                  <hr className="m-0 customHR"></hr>
                                </td>
                              </tr>
                            </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <hr className="mt-0 mb-1"></hr>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <CustomSizePerPage
                        getData={getData}
                        currentSizePerPage={currentSizePerPage}
                      />
                      <div className="dataTables_info">
                        Showing{" "}
                        {recordCount > 0
                          ? (currentPage - 1) * currentSizePerPage + 1
                          : 0}{" "}
                        to{" "}
                        {recordCount > currentPage * currentSizePerPage
                          ? currentPage * currentSizePerPage
                          : recordCount}{" "}
                        of {recordCount} entries
                      </div>
                      <CustomPaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        currentSizePerPage={currentSizePerPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
      <Modal
        className="fade"
        show={showLetterRefDocModal}
        onHide={setShowLetterRefDocModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowLetterRefDocModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="MaterialPhotos-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="MaterialPhotos-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="2%"></th>
                          <th width="98%" style={{ textAlign: "left" }}>
                            File Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {listOfLetterRefDoc?.length > 0 ? (
                          listOfLetterRefDoc?.map((item, indx) => (
                            <tr key={indx}>
                              <td style={{ textAlign: "left" }}>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View"
                                  onClick={() => {
                                    window.open(
                                      item.LetterRefImageFilePath
                                        ? item.LetterRefImageFilePath
                                        : item.viewFile
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item?.LetterRefImageFileName
                                  ? item?.LetterRefImageFileName
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showInwardStatisticsModal}
        onHide={setShowInwardStatisticsModal}
        size="xl"
        dialogClassName="fullWidthModal"
      >
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <Modal.Header>
            <Modal.Title>Inward Statistics</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowInwardStatisticsModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div
              className="table-responsive active-projects style-1 shorting"
              style={{ maxHeight: "450px" }}
            >
              <div
                id="InwardStatistics-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="InwardStatistics-tbl"
                  className="table dataTable no-footer"
                >
                  <thead className="fixedheader">
                    <tr>
                      <th>Sr No.</th>
                      <th>Inward No</th>
                      <th>TC No</th>
                      <th>Test Name</th>
                      <th>Inward</th>
                      {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                        <th>Inward Approved</th>
                      ) : (
                        ""
                      )}
                      <th>Testing</th>
                      {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                        <th>Testing Approved</th>
                      ) : (
                        ""
                      )}
                      <th>Printing</th>
                      {AuthUser?.Permissions?.DispatchReport == 1 && (
                        <th>Dispatch Report</th>
                      )}
                      {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                        <th>Dispatch Material</th>
                      ) : (
                        ""
                      )}

                      <th style={{ textAlign: "left" }}>
                        Re-Test / Amendment / Revise
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listOfInwardStatistics?.length > 0 ? (
                      listOfInwardStatistics?.map((item, idx) => (
                        <tr>
                          <td>{idx + 1}</td>
                          <td>{item?.InwardNo}</td>
                          <td>
                            {item?.TCNo}{" "}
                            {item?.IsHold ? (
                              <>
                                <b>[Hold]</b>
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={idx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item?.HoldReason}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            {item?.ListOfTests?.map((t) => (
                              <>
                                {t.TestName}
                                <br></br>
                              </>
                            ))}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item?.IsInwardDone ? (
                              <span style={{ color: "green" }}>
                                Done {" on "}
                                {item?.InwardDoneDate}
                                {" by "} {item?.InwardDoneBy}
                              </span>
                            ) : (
                              <span style={{ color: "red" }}>Pending</span>
                            )}
                          </td>
                          {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.InwardApprovalRequired ==
                            true ? (
                            <td style={{ textAlign: "center" }}>
                              {item?.IsInwardApproved ? (
                                <span style={{ color: "green" }}>
                                  Done {" on "}
                                  {item?.InwardApprovedDate}
                                  {" by "} {item?.InwardApprovedBy}
                                </span>
                              ) : (
                                <span style={{ color: "red" }}>
                                  {item?.InwardCurrentStatus == 6
                                    ? "Revise & Rectify"
                                    : item?.InwardCurrentStatus == 7
                                    ? "Rejected"
                                    : "Pending"}
                                </span>
                              )}
                            </td>
                          ) : (
                            ""
                          )}
                          <td>
                            {item?.ListOfTests?.map((t) => (
                              <>
                                {t?.TestName} {" - "}
                                {t?.IsCancel == true ? (
                                  <span style={{ color: "red" }}>
                                    Cancelled
                                  </span>
                                ) : t?.IsTestingDone ? (
                                  <span style={{ color: "green" }}>
                                    Done {" on "}
                                    {t?.TestingDoneDate}
                                    {" by "} {t?.TestingDoneBy}
                                  </span>
                                ) : (
                                  <span style={{ color: "red" }}>Pending</span>
                                )}
                                <br></br>
                              </>
                            ))}
                          </td>

                          {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.InwardApprovalRequired ==
                            true ? (
                            <td>
                              {item?.ListOfTests?.map((t) => (
                                <>
                                  {t?.TestName} {" - "}
                                  {t?.IsCancel == true ? (
                                    <span style={{ color: "red" }}>
                                      Cancelled
                                    </span>
                                  ) : t?.IsTestingApproved ? (
                                    <span style={{ color: "green" }}>
                                      Done {" on "}
                                      {t?.TestingApprovedDate}
                                      {" by "} {t?.TestingApprovedBy}
                                    </span>
                                  ) : (
                                    <span style={{ color: "red" }}>
                                      Pending
                                    </span>
                                  )}
                                  <br></br>
                                </>
                              ))}
                            </td>
                          ) : (
                            ""
                          )}

                          <td style={{ textAlign: "center" }}>
                            {item?.IsPrintingDone ? (
                              <span style={{ color: "green" }}>
                                Done {" on "}
                                {item?.PrintingDoneDate}
                                {" by "} {item?.PrintingDoneBy}
                              </span>
                            ) : (
                              <span style={{ color: "red" }}>Pending</span>
                            )}
                          </td>
                          {(AuthUser?.Permissions?.DispatchReport == 1) &
                            7(
                              <td>
                                {item?.IsReportDispatchDone ? (
                                  <>
                                    <span style={{ color: "green" }}>
                                      Done {" on "}
                                      {item?.ReportDispatchDoneDate}
                                      {" by "} {item?.ReportDispatchDoneBy}
                                    </span>
                                    <br></br>
                                    {item?.CourierName}
                                    <br></br>
                                    {item?.CourierDispatchNo}
                                  </>
                                ) : (
                                  <span style={{ color: "red" }}>Pending</span>
                                )}
                              </td>
                            )}
                          {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                            <td style={{ textAlign: "center" }}>
                              {item?.IsMaterialDispatch ? (
                                <span style={{ color: "green" }}>
                                  Done {" on "}
                                  {item?.MaterialDispatchDoneDate}
                                  {" by "} {item?.MaterialDispatchDoneBy}
                                </span>
                              ) : (
                                <span style={{ color: "red" }}>Pending</span>
                              )}
                            </td>
                          ) : (
                            ""
                          )}

                          <td style={{ textAlign: "left" }}>
                            {item?.ListOfReTests?.map((t) => (
                              <>
                                {t?.TestName} {" - "}
                                <span className="text-primary">
                                  Retest on {t?.RetestDate} by {t?.RetestBy}
                                </span>
                                <br></br>
                              </>
                            ))}
                            {item?.ListOfAmendmentTests?.map((t) => (
                              <>
                                {t?.TestName} {" - "}
                                <span className="text-primary">
                                  Amendment on {t?.AmendmentDate} by{" "}
                                  {t?.AmendmentBy}
                                </span>
                                <br></br>
                              </>
                            ))}
                            {item?.ListOfRewise?.map((t) => (
                              <>
                                {t?.RewiseNo} {" - "}
                                <span className="text-primary">
                                  Revise on {t?.RewiseDate} by {t?.RewiseBy}
                                </span>
                                <br></br>
                              </>
                            ))}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={16}
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showSendMachineCertificateModal}
        onHide={setShowSendMachineCertificateModal}
        backdrop="static"
        size="lg"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikSendMachineCertificate}>
            <Form onSubmit={formikSendMachineCertificate.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Machine Certificate</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowSendMachineCertificateModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="smcMachineCertificate-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="smcMachineCertificate-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "5%" }}></th>
                              <th style={{ width: "50%" }}>Machine Name</th>
                              <th style={{ width: "45%", textAlign: "left" }}>
                                Certificate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {smcListOfMachineCertificate?.length > 0 ? (
                              smcListOfMachineCertificate?.map((item, idx) => (
                                <tr>
                                  <td>{idx + 1}</td>
                                  <td>{item?.MachineName}</td>
                                  <td style={{ textAlign: "left" }}>
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.MachineCertificateFilePath
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye" />
                                    </Link>
                                    &nbsp;{item.MachineCertificateFileName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowSendMachineCertificateModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
    </>
  );
};

export default CustomerInward;
